'use strict';

const React = require( 'react' );
const getAirportInfo = require( '../getAirportInfo' );
const propTypes = require('prop-types');
const Helpers = require( '../../../../../_plugins/lib/helpers' );
const { string } = propTypes;
const createReactClass = require('create-react-class');

const HotelCrossSell = createReactClass({
  mixins: [Helpers],

  propTypes: {
    pageName: string.isRequired,
    priceFormat: string
  },

  getAirportData( ) {
    const { pageName } = this.props;
    const airport = getAirportInfo( pageName, true );
    airport.location = airport.name.replace( ' ', '-' );
    airport.page = airport.location.toLowerCase( );
    airport.page = airport.page.replace( 'eastmidlands', 'east-midlands' );
    if (
      airport.page &&
      airport.page.indexOf( 'gatwick' ) < 0 &&
      airport.page.indexOf( 'stansted' ) < 0 &&
      airport.page.indexOf( 'heathrow' ) < 0
    ) airport.page += '-airport';
    airport.page += '-parking/' + airport.page + '-hotels-with-parking.html';
    return airport;
  },

  getPriceFromFeed( ) {
    const { priceFormat } = this.props;
    const { code } = this.getAirportData( );
    if ( code.length === 3 ) { //Location price fetch
      try {
        const { prices } = require( '../../../../../config/exports/prices/hotels/' + code + '.json' );
        if ( prices.error ) return false;
        return priceFormat + prices.lowestPrice;
      } catch ( e ) {
        if (typeof window === 'undefined') return false;
        const element = this.$( '#hotelCrossSell .priceSmall' );
        return element ? element.innerHTML : false;
      }
    }
  },

  render( ) {
    const price = this.getPriceFromFeed( );
    const { name, page } = this.getAirportData( );
    if ( !page || !price ) return null;


    return (
      <div id="hotelCrossSell" className="well">
        <h3>{ name } Airport Hotels with Parking</h3>
        <p>If you are driving to the airport, an airport hotel with parking is a great way to travel.</p>
        <p>From only <span className="priceSmall">{ price }</span> <small>( 1 night and 8 days parking )</small></p>
        <button className="btn submit btn-primary btn-mid">
          <a title="More hotels page" href={ page }>Search <i className="fa fa-arrow-right" /></a>
        </button>
      </div>
    );
  }
});

module.exports = HotelCrossSell;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/menu/hotelCrossSell.jsx